module.exports = [{"code":1,"name":"西向东（东）"},{"code":2,"name":"东向西（西）"},{"code":3,"name":"北向南（南）"},{"code":4,"name":"南向北（北）"},{"code":5,"name":"西南向东北（东北）"},{"code":"6","name":"东北向西南（西南）"},{"code":"7","name":"西北向东南（东南）"},{"code":"8","name":"东南向西北（西北）"},{"code":"9","name":"其他"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/direction.json
// module id = /B93
// module chunks = 11